import { render, staticRenderFns } from "./MailKonfiguration.vue?vue&type=template&id=20b6ca19&scoped=true&"
import script from "./MailKonfiguration.vue?vue&type=script&lang=js&"
export * from "./MailKonfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6ca19",
  null
  
)

export default component.exports